import {
  FailuresMap,
  ObbXOfNLegParams,
  ObbLeg as ObbBettingLeg,
} from "@ppb/tbd-store/state/betting/obb-betting/ObbBetting.types";
import { areObjectsDeepEqual } from "@ppb/tbd-store/helpers/obj-deep-equal-comparator";
import { SUSPENDED_FAILURE_CODES } from "@ppb/tbd-store/state/betting/obb-betting/obb-betting.constants";

export type ObbMultipleDetails = { id: string; x: number };

export const hasAnyObbSuspendedFailure = (failures: FailuresMap["legs"], legsIds: string[]): boolean =>
  legsIds.some((legId) => failures[legId] && SUSPENDED_FAILURE_CODES.includes(failures[legId]));

export const isCombinedPotentialBet = (potentialBetLegs: ObbBettingLeg[]): boolean => {
  return potentialBetLegs.some((leg) => "baseBets" in leg.params);
};

export const hasSameBaseBets = (potentialBetLegs: ObbBettingLeg[], multipleLegs: ObbBettingLeg[]): boolean => {
  return Object.values(potentialBetLegs).some((leg) =>
    Object.values(multipleLegs).some((multipleLeg) =>
      areObjectsDeepEqual(
        { baseBets: (leg.params as ObbXOfNLegParams).baseBets },
        { baseBets: (multipleLeg.params as ObbXOfNLegParams).baseBets },
        { ignoreOrder: true },
      ),
    ),
  );
};
